import { Type } from 'class-transformer';
import { Violation } from './violation';

export class ViolationAggregate {
    readonly id: string;
    readonly label: string;

    @Type(() => Date)
    readonly since: Date;

    @Type(() => Date)
    readonly until: Date;

    @Type(() => Violation)
    readonly violations: Violation[];

    getViolationById(idViolation: number): Violation | null {
        return this.violations.find(v => v.id === idViolation) || null;
    }

}
